import { render, staticRenderFns } from "./invoiceBalanceAdjustment.vue?vue&type=template&id=2864b74d"
import script from "./invoiceBalanceAdjustment.vue?vue&type=script&lang=js"
export * from "./invoiceBalanceAdjustment.vue?vue&type=script&lang=js"
import style0 from "./invoiceBalanceAdjustment.vue?vue&type=style&index=0&id=2864b74d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports